import { chain } from 'lodash';
import { Problem } from '../models/problems.model';
import { Utils } from '../services/utils';

/** Same ordering as application cache after {@link ApplicationCacheService.setProblemCache}. */
export function orderEncounterProblemsForDisplay(
  problems: Problem[],
  currentEncounterId: string,
): Problem[] {
  const encounterId = (currentEncounterId || '').trim();
  const isActive = (p: Problem) =>
    !!encounterId &&
    (p.encounterId === encounterId || p.isChecked);

  const currentProblems = chain(problems)
    .filter(isActive)
    .orderBy(
      [(p) => p.alphaOrder ?? 'ZZZ', 'createdAt'],
      ['asc', 'desc'],
    )
    .value();

  const labeledMap = new Map<string, string>();
  currentProblems.forEach((problem, index) => {
    labeledMap.set(
      problem.id,
      problem.alphaOrder ?? Utils.getAlphabetLabel(index),
    );
  });

  return chain(problems)
    .map((problem) => ({
      ...problem,
      alphaOrder: isActive(problem)
        ? labeledMap.get(problem.id)
        : problem.alphaOrder,
    }))
    .orderBy([(p) => (isActive(p) ? p.alphaOrder ?? 'ZZZ' : 'ZZZ')], ['asc'])
    .value();
}
